import { render, staticRenderFns } from "./inbox_imc.vue?vue&type=template&id=834ba2fa&scoped=true&"
import script from "./inbox_imc.vue?vue&type=script&lang=js&"
export * from "./inbox_imc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834ba2fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('834ba2fa')) {
      api.createRecord('834ba2fa', component.options)
    } else {
      api.reload('834ba2fa', component.options)
    }
    module.hot.accept("./inbox_imc.vue?vue&type=template&id=834ba2fa&scoped=true&", function () {
      api.rerender('834ba2fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/inbox/inbox_imc.vue"
export default component.exports